import { toast } from 'react-toastify';
import axios from '@utils/axios';
import Translate from '../components/translate/conf';
import React, { Component } from 'react';
import ModalLoading from '@app/components/modal-loading/modal-loading';
import { date } from 'yup';

class BackupRestorePage extends Component {

  // API Endpoints
  constructor(props) {
    super(props);
    this.backupLink = React.createRef();
    this.checkIfRebooting();
  }

  backupLink = null;
  timerId = -1;
  state = {
    mLoading: false,
  }

  checkIfRebooting = async () => {
    try {
      let response = await axios('/api/systeminfo');
      let reboot = response.data.data.reboot;
      let err = response.data.err;
      if (err === '' && reboot == 1) {
        this.waitProcess(true)
      }
    } catch (e) {
      console.log(e)
    }
  }

  handleSelectFile = (e) => {
    let result = null
    let filename = e.target.files[0].name;
    if (filename.substr(-3) == 'bin') {
      result = filename
    } else {
      toast.error(<Translate transVar="FirmwareUpgrade.InvalidExtensionFile" />)
    }
    this.setState({
      fw_filename: result
    })
  }

  monitorRebooting = async () => {
    let err = '';
    try {
      let response = await axios({ url: '/api/systeminfo', timeout: 900 });
      err = response.data.err;
    } catch (e) {
      err = e;
    }

    if (err === 'Unauthorized access') {
      toast.success(<Translate transVar="ManagementCard.ApplySuccess" />)
      this.waitProcess(false)
      setTimeout(() => axios('/api/login').catch(), 3000);
    }
  }

  waitProcess = (en) => {
    if (en) {
      if (this.timerId > 0) return;
      this.timerId = setInterval(this.monitorRebooting, 1000)
      this.setState({ mLoading: true });
    } else {
      if (this.timerId === -1) return;
      clearInterval(this.timerId);
      this.timerId = -1;
      this.setState({ mLoading: false });
    }
  }

  // File Submit Handler
  handleSubmitFile = (e) => {
    if (this.state.fw_filename != null) {
      this.waitProcess(true)
      axios.post(
        '/api/management/config',
        new FormData(e.target),
        {
          headers: {
            "Content-type": "multipart/form-data",
          },
        }
      ).then((res) => {
        if (res.data.err !== undefined && res.data.err !== '') {
          this.waitProcess(false)
          toast.error(res.data.err)
        }
      })
    } else {
      toast.error(<Translate transVar="ManagementCard.EmptySelectFile" />);
    }
    e.preventDefault()
  }

  // File Submit Handler
  handleGetBackup = (e) => {
    axios({ method: 'get',url:'/api/management/config',responseType:'stream'}).then((res) => {
      let dt = new Date()
      let datetime = ("0" + dt.getDate()).slice(-2) + ''
      datetime += ("0" + (dt.getMonth() + 1)).slice(-2) + ''
      datetime += dt.getFullYear() + ''
      datetime += dt.getHours() + ''
      datetime += dt.getMinutes()
      this.backupLink.current.href = window.URL.createObjectURL(new Blob([res.data]));
      this.backupLink.current.setAttribute('download', 'OLT-Think_backup-'+datetime+'.bin');
      this.backupLink.current.click()
    })
    e.preventDefault()
  }

  // render from here
  render() {
    return (
      <>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1><Translate transVar='menusidebar.label.ManagementCard.BackupRestore' /></h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Translate transVar='menusidebar.label.ManagementCard.Parent' />
                  </li>
                  <li className="breadcrumb-item active">
                    <Translate transVar='menusidebar.label.ManagementCard.BackupRestore' />
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="container-fluid">

            <div className="row">
              <div className="col-md-6">
                <div className="card card-primary">
                  <div className="card-header">
                    <h3 className="card-title"><Translate transVar='ManagementCard.BackupRestore.Restore' /></h3>
                  </div>
                  <ModalLoading show={this.state.mLoading} />
                  <form onSubmit={this.handleSubmitFile}>
                    <div className="card-body">
                      <div className="form-group">
                        <label><Translate transVar='ManagementCard.BackupRestore.SelectRestoreFile' /></label>
                      </div>
                      <div className="form-group">
                        <input type="file" name="files" onChange={this.handleSelectFile} accept=".bin" />
                      </div>
                      <div className="form-group">
                        <i className="info">- <Translate transVar='ManagementCard.AfterRebootLogout' /></i>
                      </div>
                    </div>
                    <div className="card-footer">
                      <button type="submit" className="btn btn-primary"><Translate transVar='Button.Apply' /></button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="card card-primary">
                  <div className="card-header">
                    <h3 className="card-title"><Translate transVar='ManagementCard.BackupRestore.Backup' /></h3>
                  </div>
                  <form onSubmit={this.handleGetBackup}>
                    <div className="card-body">
                      <div className="form-group">
                        <label htmlFor="InputIPAddress"><Translate transVar='ManagementCard.BackupRestore.ApplyBackup' /></label>
                        <a ref={this.backupLink} href="#" target="_blank" style={{display:'none'}}/>
                      </div>
                    </div>
                    <div className="card-footer">
                      <button type="submit" className="btn btn-primary"><Translate transVar='Button.Apply' /></button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default BackupRestorePage;